import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ModalController, Platform } from '@ionic/angular';
import { Subscription } from "rxjs";
import { LanguageService } from "src/app/service/language-service/language.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-platform-upgrade-available",
  templateUrl: "./platform-upgrade-available.component.html",
  styleUrls: ["./platform-upgrade-available.component.scss"],
})
export class PlatformUpgradeAvailableComponent implements OnInit, OnDestroy {
  @Input() isForcedToUpdate: boolean;
  @Input() dbVersion: string = "";
  userVersion:string = "";
  language:string = "es";
  laguageSub: Subscription;

  constructor(
    private modalCtrl: ModalController,
    private platform: Platform,
    private languageService: LanguageService,
  ) {
  }

  ngOnInit() {
    this.subLanguageConfig();
    if (this.platform.is("ios")) {
      this.userVersion = environment.APP_VERSION_IOS;
    }
    if (this.platform.is("android")) {
      this.userVersion = environment.APP_VERSION_ANDROID;
    }
  }

  updateAndroid() {
    this.modalCtrl.dismiss({
      confirm: true
    });
  }
  cancelar() {
    this.modalCtrl.dismiss()
  }

  subLanguageConfig() {
    this.laguageSub = this.languageService.getCurrentLang().subscribe(lang => {
      this.language = lang;
    });
  }
  ngOnDestroy() {
    this.laguageSub?.unsubscribe();
	}
}
